import React from 'react';

interface ChildConnectorElbowProps {
  readonly className: string;
}

/** Curved elbow from a vertical trunk (x=12) into a child row (x=42). The trunk itself is drawn by the caller's CSS. */
function ChildConnectorElbow({ className }: ChildConnectorElbowProps): React.ReactElement {
  return (
    <svg className={className} viewBox="0 0 42 48" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path
        d="M 12 0 Q 12 16 42 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ChildConnectorElbow;
